import Navbar from "../components/navbar";
import Hero from "../components/Hero";
import Footer from "../components/Footer";
import Trip from "../components/Trip";
import ServiceImg from "../assets/service.jpg";
function Service() {
  return (
    <>
      <Navbar />
      <Hero 
      cName="hero-mid" 
      heroImg={ServiceImg} 
      title="Service" 
      btnClass="hide" />
      <Trip/>
        <Footer/>
    </>
  );
}

export default Service;
